<template>
  <div class="solutions">
    <div class="container">
      <!-- item -->
      <div class="solutions__row will-animation inFocus" data-transition-delay="0.3" style="transition-delay: 0.3s;">
        <div class="solutions__col">
          <div class="solutions__content">
            <div class="solutions__title">Гостиная</div>
            <div class="solutions__descript">Сдайте пульт управления телевизором в&nbsp;музей техники. Запускайте одной фразой целые технологические сценарии. Просто скажите: «Siri, включи фильм»,&nbsp;— и&nbsp;умный дом закроет шторы, приглушит свет и&nbsp;включит мультимедийную систему. Раньше такое было только в&nbsp;кино!</div>
          </div>
        </div>
        <div class="solutions__col solutions__col_cover">
          <img src="../assets/images/solutions/living_room.jpg" alt="">
        </div>
      </div>
      <!-- item -->
      <div class="solutions__row solutions__row_reverse will-animation">
        <div class="solutions__col">
          <div class="solutions__content">
            <div class="solutions__title">Кухня</div>
            <div class="solutions__descript">Горячая чашка кофе и&nbsp;тосты будут ждать с&nbsp;утра вашего пробуждения. Любимый утренний плейлист заиграет, когда вы&nbsp;зайдёте на&nbsp;кухню. Робот-пылесос уберёт все крошки с&nbsp;пола, пока вас не&nbsp;будет дома. Потопа после вас не&nbsp;будет&nbsp;— датчики протечки воды в&nbsp;случае чего перекроют трубы. Не&nbsp;бойтесь, что оставили включенной плиту&nbsp;— умный дом держит всё под контролем.</div>
          </div>
        </div>
        <div class="solutions__col solutions__col_cover">
          <img src="../assets/images/solutions/kitchen.jpg" alt="">
        </div>
      </div>
      <!-- item -->
      <div class="solutions__row will-animation">
        <div class="solutions__col">
          <div class="solutions__content">
            <div class="solutions__title">Детская</div>
            <div class="solutions__descript">С&nbsp;умным домом воспитание детей станет проще. Система сообщит, если в&nbsp;детской открылось окно. Видеоняня для малышей не&nbsp;заменит настоящую, но&nbsp;позволит приглядывать за&nbsp;обстановкой. Невыключенная на&nbsp;ночь игровая приставка выключится сама. А&nbsp;от&nbsp;климатической системы детям будет ни&nbsp;горячо, ни&nbsp;холодно: комфортную температуру и&nbsp;влажность можно настроить в&nbsp;пару кликов.</div>
          </div>
        </div>
        <div class="solutions__col solutions__col_cover">
          <img src="../assets/images/solutions/nursery.jpg" alt="">
        </div>
      </div>
      <!-- item -->
      <div class="solutions__row solutions__row_reverse will-animation">
        <div class="solutions__col">
          <div class="solutions__content">
            <div class="solutions__title">Прихожая</div>
            <div class="solutions__descript">Забудьте про ключи. Пришёл клинер, пока вы&nbsp;в&nbsp;ванной? Откройте дверь со&nbsp;смартфона&nbsp;— умный домофон покажет вам, кто звонит. Он&nbsp;даже позволит увидеть, кто приходил, пока вас не&nbsp;было дома.</div>
          </div>
        </div>
        <div class="solutions__col solutions__col_cover">
          <img src="../assets/images/solutions/hall.jpg" alt="">
        </div>
      </div>
      <!-- item -->
      <div class="solutions__row will-animation">
        <div class="solutions__col">
          <div class="solutions__content">
            <div class="solutions__title">Спальня</div>
            <div class="solutions__descript">Спите на&nbsp;здоровье&nbsp;— система рекуперации тепла и&nbsp;открытия окон позаботится о&nbsp;том, чтобы в&nbsp;доме был оптимальный баланс кислорода и&nbsp;углекислого газа. Беда по&nbsp;имени солнце будит вас раньше времени? Больше не&nbsp;будет! Автоматизированные карнизы и&nbsp;умные шторы пустят солнечный свет в&nbsp;комнату по&nbsp;будильнику, а&nbsp;встроенная акустика начнёт играть энергичный плейлист для пробуждения.</div>
          </div>
        </div>
        <div class="solutions__col solutions__col_cover">
          <img src="../assets/images/solutions/bedroom.jpg" alt="">
        </div>
      </div>
      <!-- item -->
      <div class="solutions__row solutions__row_reverse will-animation">
        <div class="solutions__col">
          <div class="solutions__content">
            <div class="solutions__title">Придомовая территория</div>
            <div class="solutions__descript">Вам придётся найти себе хобби, поскольку с&nbsp;ежедневными хлопотами умный дом справится сам. Накормит домашних животных, польёт цветы, установит нужную температуру в&nbsp;теплице и&nbsp;бассейне, растопит лёд на&nbsp;крыльце, крыше и&nbsp;в&nbsp;водостоках.<br><br>
              Умный дом не&nbsp;только самостоятельный, но&nbsp;и&nbsp;очень наблюдательный. Системы видеонаблюдения заранее поймут, что вы&nbsp;приближаетесь к&nbsp;дому, откроют ворота и&nbsp;сопроводят до&nbsp;двери. Если&nbsp;же на&nbsp;территории появится незваный гость, датчики активируют систему безопасности, включат сирену и&nbsp;немедленно отправят вам сообщение.
            </div>
          </div>
        </div>
        <div class="solutions__col solutions__col_cover">
          <img src="../assets/images/solutions/yard.jpg" alt="">
        </div>
      </div>
      <!-- item -->
      <div class="solutions__row will-animation">
        <div class="solutions__col">
          <div class="solutions__content">
            <div class="solutions__title">Служебные помещения</div>
            <div class="solutions__descript">Тепло приходит в&nbsp;умный дом только тогда, когда нужно. Температурные датчики определят, когда стоит начать топить, и&nbsp;протопят загородный дом, пока вы&nbsp;в&nbsp;пути. У&nbsp;вас газовая котельная? В&nbsp;случае аварии умный дом прекратит подачу воды, газа и&nbsp;электричества, и&nbsp;мгновенно оповестит вас о&nbsp;случившемся.</div>
          </div>
        </div>
        <div class="solutions__col solutions__col_cover">
          <img src="../assets/images/solutions/other.jpg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';

export default {
  mounted() {
    var _this = this;
    this.elements = $('.will-animation');

    $(window).on('scroll', this.scrollHandler.bind(this));
    setTimeout(function() {
      $('html, body').scrollTop(0);
      $('.main').removeClass('load');
      _this.scrollHandler.call(_this);
    }, 0);
  },
  methods: {
    scrollHandler: function() {
      var self = this;
      var delay, duration, animationType, transitionDelay;

      self.elements.each(function(i, item) {
        var el = $(item);

        if (!el.hasClass('inFocus')) {
          delay = parseFloat(el.data('animation-delay'));
          duration = parseFloat(el.data('animation-duration'));
          animationType = el.data('animation-type');
          transitionDelay = el.data('transition-delay');

          var focus = self.inFocus(item);

          if (focus.fullInWindow || focus.percHWindow > 25) {
            el.addClass('inFocus');

            // fix for safary desktop
            var $btn = el.find('.btn_animate');
            $btn.removeClass('btn_animate');

            setTimeout(function() {
              $btn.addClass('btn_animate');
            }, 0);

            if (animationType) {
              el.addClass(animationType);
            }
            if (delay) {
              el.css('animation-delay', delay + 's');
            }
            if (duration) {
              el.css('animation-duration', duration + 's');
            }
            if (transitionDelay) {
              el.css('transition-delay', transitionDelay + 's');
            }
          }
        }
      });
    },
    inFocus: function(elem) {
      var coords = elem.getBoundingClientRect();
      var top = coords.top;
      var bottom = coords.bottom;
      var h = document.documentElement.clientHeight;

      var isFocus = {
        // true, если проверяемый элемент полностью в окне
        fullInWindow: false,
        // true, если лемент частично в окне браузера
        partiallyInWindow: false,
        // true, если элемент полностью за пределами окна
        outsideWindow: false,
        // Отношение высоты элемента к высоте экрана. Если > 1, то элемент никогда не будет на 100% в экране
        heightRatio: +(Math.abs(top - bottom) / h).toFixed(3),
        // Определяет процент от высоты элемента, на который элемент находится в окне браузера
        percInWindow: 0,
        // Определяет сколько процентов высоты окна браузера занимает элемент на текущий момент
        percHWindow: 0
      };

      // Элемент полностью за пределами окна
      if (top < 0 && bottom < 0 || top > h && bottom > h) {
        isFocus.fullInWindow = false;
        isFocus.partiallyInWindow = false;
      }

      // Элеменит полностью в окне. Возможно только при isFocus.heightRatio < 1
      else if (top >= 0 && top <= h && bottom >= 0 && bottom <= h) {
        isFocus.fullInWindow = true;
        isFocus.partiallyInWindow = false;
        isFocus.percInWindow = 100;
        isFocus.percHWindow = +(isFocus.percInWindow * isFocus.heightRatio).toFixed(3);
      }

      // Элемент частично в окне (нижняя его часть видима)
      else if (top <= 0 && bottom >= 0 && bottom < h) {
        isFocus.partiallyInWindow = true;
        isFocus.percInWindow = +((Math.abs(top - bottom) - Math.abs(top)) / Math.abs(top - bottom) * 100).toFixed(3);
        isFocus.percHWindow = +(isFocus.percInWindow * isFocus.heightRatio).toFixed(3);
      }

      // Элемент частично в окне (верхняя его часть видима)
      else if (top >= 0 && top < h && bottom > h) {
        isFocus.partiallyInWindow = true;
        isFocus.percInWindow = +((h - Math.abs(top)) / Math.abs(top - bottom) * 100).toFixed(3);
        isFocus.percHWindow = +(isFocus.percInWindow * isFocus.heightRatio).toFixed(3);
      }

      // Высота элемента больше высоты окна и элемент занимает все окно
      else if (isFocus.heightRatio > 1 && top <= 0 && bottom > h) {
        isFocus.partiallyInWindow = true;
        isFocus.percInWindow = +(100 / isFocus.heightRatio).toFixed(3);
        isFocus.percHWindow = 100;
      }

      isFocus.outsideWindow = !isFocus.partiallyInWindow && !isFocus.percInWindow;

      return isFocus;
    }
  }
}
</script>
<style>
.solutions {
  margin-top: 77px;
  margin-bottom: 50px;
}

.solutions__row {
  display: -ms-flexbox;
  display: flex;
  margin: 75px -15px 0;
}

.solutions__row:nth-child(1) {
  margin-top: 0;
}

.solutions__row_reverse {
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
}

.solutions__row_reverse .solutions__content {
  margin-left: auto;
}

.solutions__col {
  width: 34%;
  padding: 0 15px;
}

.solutions__col_cover {
  width: 66%;
}

.solutions__title {
  font: 23px/35px "Graphik-Medium-Cy", sans-serif;
}

.solutions__descript {
  font-size: 14px;
  line-height: 21px;
  margin-top: 16px;
}

.solutions__content {
  max-width: 326px;
  margin-top: 5px;
  transform: translate3d(0, 30px, 0);
  transition: .25s ease;
}

.inFocus .solutions__content {
  transform: translate3d(0, 0, 0);
}

@media screen and (max-width: 767px) {
  .solutions__row {
    flex-direction: column;
    margin: 15px -15px;
  }
  .solutions__col {
    width: 100%;
  }
  .solutions__descript {
    margin-bottom: 10px;
  }
}
</style>